import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface ReviewAIType {
	emotion: number;
	etc: string;
	keyword: string;
	summary: string;
}

const key = `useReviewAI`;

/** ```
 * 리뷰 AI 조회
 *   `/portal/product/${goodsCd}/review/ai-info`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const getPath = (goodsCd?: string): string | null => {
	if (!goodsCd) return "";
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/portal/product/${goodsCd}/review/ai-info`;
};

/** ```
 * 리뷰 AI 조회
 *   `/portal/product/${goodsCd}/review/ai-info`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const useReviewAI = (goodsCd?: string, options?: Partial<UseQueryOptions<Response<ReviewAIType>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(goodsCd)],
		queryFn: () => useConfigureAxios({url: getPath(goodsCd)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		throwOnError: false,
		...options,
	});

export default useReviewAI;
export {getPath, key};
export type {ReviewAIType};
